import axios, { AxiosResponse } from "axios";
import { baseUrl } from "../../urls";

export const logOutWithCookieService = (): Promise<AxiosResponse<{}>> =>
  axios.post(`${baseUrl}/authorization/cookie-logout`);
